export const appointmentEn = {
  "Matin": "Morning",
  "Soir": "Evening",
  "Lundi": "Monday",
  "Mardi": "Tuesday",
  "Mercredi": "Wednesday",
  "Jeudi": "Thursday",
  "Vendredi": "Friday",
  "Samedi": "Saturday",
  "Dimanche": "Sunday",
  "Rendez-vous DR.": "Appointments DR.",

  "Montée": "Start",
  "Descente": "Fin",
  "Temps": "Time",
  "NBS.SN": "NB.S",
  "Nombre de seance": "Number of sessions",
  "Jour du travail": "Working days",
  "Pause": "Break",
  "Filter": "Filter",
  "Supprimer le rendez-vous": "Delete the Appointment",
  "Supprimer l'acte": "Delete the act",


  // Server side 

  "Le rendez-vous existe deja": "The appointment already exists",
  "Le patient est obligatoire": "The patient is obligatory",
  "Date de rendez-vous est obligatoire": "Appointment date is mandatory",
  "Heure de rendez-vous est obligatoire": "Appointment time is required",
  "Vous etes obligé de choisir un jour.": "You have to choose a day.",
  "deja existe": "already exists",
  "le nom est obligatoire": "Name is required",
  "Choisir un temps partiel": "Choose part-time",
  "Donner la date du debut du : matin": "Give the start date of: morning",
  "Donner la date du debut du : soir": "Give the start date of: evening",
  "Donner la date du descente du : matin": "Give the date of descent: morning",
  "Donner la date du descente du : soir": "Give the date of the descent: evening",

  "Démain": "Tomorrow",
  "Aprés Démain": "After Tomorrow",
  "Hier": "Yesterday",
  "Avant-hier": "Before yesterday",
  "Aprés": "After",
  "jours": "days",
  "Avant": "Before",
  

}
